import { render, staticRenderFns } from "./DottedMenu.vue?vue&type=template&id=b865bf0e&scoped=true&"
import script from "./DottedMenu.vue?vue&type=script&lang=js&"
export * from "./DottedMenu.vue?vue&type=script&lang=js&"
import style0 from "./DottedMenu.vue?vue&type=style&index=0&id=b865bf0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b865bf0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b865bf0e')) {
      api.createRecord('b865bf0e', component.options)
    } else {
      api.reload('b865bf0e', component.options)
    }
    module.hot.accept("./DottedMenu.vue?vue&type=template&id=b865bf0e&scoped=true&", function () {
      api.rerender('b865bf0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/DottedMenu.vue"
export default component.exports